/**
 * Handles http and resource calls in a standard way.
 *  - Sets `$pending` on the calling object (n.o. loading calls)
 *  - Displays errors to user
 *
 * @example `
 * responseHandler(Registration.resend().$promise, 'resending the email');
 * `
 */
export default /* @ngInject */ function responseHandler($log, showToast) {
    return function(promise,
                    action = 'processing your request',
                    form = this ? this.form : null,
                    retry = true) {

        /** @this {$controller} */
        let context = this || {};

        // Reset generic form errors
        if (context.form) {
            context.form.genericFormMessages = [];
        }

        // Increase loading count:
        context.$pending = context.$pending ? ++context.$pending : 1;

        // Handle errors:
        promise.catch((response) => handleError(response, action, retry));

        // Decrease loading count when done:
        promise.finally(() => context.$pending--);

        function showFieldError(field, errors=[]) {
            field.server_error = errors.join(' ');
            field.$setValidity('server_error', false);
            // Reset validity when model value changes:
            field.$viewChangeListeners.push(() => {
                field.$setValidity('server_error', true);
                field.$viewChangeListeners.pop();
            });
        }

        function showGenericErrors(errors=[]) {
            if (context.form && context.form.setFormErrors) {
                context.form.setFormErrors(errors);
            } else {
                showToast(errors.join(' '), 'error');
            }
        }

        function handleError(response={}) {
            let errorIsHandled = false;
            $log.error('Response Error', response);
            angular.forEach(response, (errors, key) => {
                // Django pattern: always returns errors as an array,
                // e.g. `{email: ['Invalid email address']}`
                if (errors instanceof Array) {
                    if (context.form) {
                        let field = context.form[key];
                        if (field) {
                            // Server reported an error for a field that
                            // was in our form:
                            showFieldError(field, response[key]);
                        } else {
                            // Server reported a generic error, or for a
                            // field not in our form:
                            showGenericErrors(response[key]);
                        }
                    } else {
                        // No form tied to controller,
                        // showing generic error toast:
                        showGenericErrors(errors);
                    }
                    errorIsHandled = true;
                }
            });

            // Generic error handling fallback:
            if (!errorIsHandled) {
                let errWhileAction = `A server error occurred while ${action}. `;
                let tryAgain = retry ? ' Please try again later.' : '';
                showGenericErrors([errWhileAction + tryAgain]);
            }
        }

        return promise;
    };
}



// WEBPACK FOOTER //
// ./forms/services/response-handler.js